import React from 'react'
import ResetPasswordContent from '../Components/ResetPassword/';
import PublicLayout from '../Layouts/PublicLayout';

export default function ResetPassword() {
  return (
    <PublicLayout>
      <div className='public-row mx-auto'>
        <ResetPasswordContent />
      </div>
    </PublicLayout>
  )
}
